import React from "react";

interface TableCaptionProps {
  caption: string;
}

export const TableCaption = ({ caption }: TableCaptionProps) => {
  return <caption className="sr-only">{caption}</caption>;
};
